<template>
 <svg :class="['svg-icon', 'svg-icon' + iconName]" ><use :xlink:href="iconName"></use></svg>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  methods: {
  },
  computed: {
    iconName () {
      return `#icon-${this.name}`
    }
  }
}
</script>
<style lang="scss" scoped>
.svg-icon
{
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/assets/svgs/index.vue